module.exports = __webpack_public_path__ + "fonts/PolySans-Median.03b887f.woff";